import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TaskToDisplay } from '../../models/company-tasks/task-to-display';

@Injectable({ providedIn: 'root' })
export class CompanyTasksService {
    private apiUrl = environment.apiUrl + '/api/companies-tasks';
    constructor(private http: HttpClient) {}

    getCompanyTasks(companyId: string, documentType: number): Observable<Array<TaskToDisplay>> {
        return this.http.get<Array<TaskToDisplay>>(`${this.apiUrl}/${companyId}/${documentType}`);
    }
}
